import { motion } from "framer-motion";
import { Quote, ArrowRight } from "lucide-react";
import { WHATSAPP_URL } from "@/data/services";

export default function Testimonials() {
  return (
    <section
      id="testimoni"
      data-testid="testimonials-section"
      className="bg-[#FDFBF7] pb-24 pt-4 lg:pb-32"
    >
      <div className="mx-auto max-w-4xl px-6 text-center lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="font-mono text-[11px] tracking-[0.4em] text-[#B76E79]">
            05 — KATA MEREKA
          </p>
          <h2 className="font-display mt-4 text-4xl text-[#1A1A1A] md:text-5xl">
            Bukti, bukan <em className="text-[#B76E79]">janji</em>
          </h2>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="relative mt-12 rounded-3xl border-2 border-dashed border-[#141318]/15 bg-white/60 p-10 md:p-14"
          data-testid="testimonials-placeholder"
        >
          <Quote size={32} className="mx-auto text-[#C9A227]" />
          <p className="font-display mt-6 text-xl italic leading-relaxed text-[#1A1A1A] md:text-2xl">
            “Belum ada testimoni di sini — dan itu disengaja.”
          </p>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-[#4A4A4A]">
            Kami memilih jujur: tidak ada ulasan palsu di halaman ini. Setiap
            cerita yang nanti menghiasi ruang ini akan datang dari pasangan,
            pemilik usaha, influencer, dan masjid yang benar-benar kami rayakan
            bersama.
          </p>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="testimonials-cta"
            className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-[#B76E79] underline-offset-4 transition-colors hover:text-[#8E4A54] hover:underline"
          >
            Jadilah cerita pertama
            <ArrowRight size={16} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
